const Password = (()=>{

    const templatePass = ()=>{
        const createDiv = document.createElement('div');
        createDiv.classList.add('pass-action');
        const template = `
            <div class="item">
                <img src="/themes/sabios_theme/sources/dist/assets/img/svg/eye.svg">
                <img src="/themes/sabios_theme/sources/dist/assets/img/svg/eye-slash.svg">
            </div>
            <div class="item">
                <p>Mostrar</p>
                <p>Ocultar</p>
            </div>
        `;
        createDiv.innerHTML += template;

        return createDiv;
    }

    const _PasswordConfig = ()=>{
        const getAllInputsPassword = document.querySelectorAll('input[type="password"');
        //While in inputs password
        getAllInputsPassword.forEach((data)=>{
            const getParent = data.parentElement;
            const template = templatePass();
            //Render template in all inputs password
            getParent.classList.add('password-block');
            getParent.prepend(template);
        });

        //Show and hidde password
        const passActions = document.querySelectorAll('.pass-action');

        passActions.forEach((data)=>{
            data.addEventListener('click', ()=>{
                const input = data.parentElement.querySelector('input');
                input.type == 'text' ? (input.type = 'password') : (input.type = 'text');
                data.classList.toggle('active');
            });
        });
    }

    /*
    *Return child functions in a objects
    */
    return{
        setHandleEvent: function(){
            try { _PasswordConfig(); } catch (error) { console.log(error) }
        }
    }
})();

/*
*Load global functions
*/
const loadPasswordHandlers = ()=>{
    Password.setHandleEvent();
}

export { loadPasswordHandlers }